const _ = require('lodash')

const commonConfig = {
  appBuild: undefined,
};

const getBrandConfig = function (brand, language, slot, vendor) {
  const targetLang = language || 'en';
  const targetSlot = slot || 'dev';
  const brandName = brand === 'ni' ? vendor + '/nissan' : vendor + '/infiniti'; // eslint-disable-line
  const brandConfig = require('./' + brandName); // eslint-disable-line
  const baseConfig = brandConfig.base;
  const langConfig = brandConfig.languages[targetLang];
  const slotConfig = brandConfig.slots[targetSlot];
  return _.merge(commonConfig, baseConfig, langConfig, slotConfig)
}

module.exports = getBrandConfig;



/*****************
 ** WEBPACK FOOTER
 ** ./config/brand/index.js
 ** module id = 86
 ** module chunks = 0
 **/